<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Please confirm what type of investor you are" />
    </template>
    <form @submit.prevent="submit">
      <div class="card-group">
        <div class="card" :class="{ 'bg-success text-white': selected('High-net') }">
          <div class="card-body">
            <h3 class="card-title text-center">High-net worth</h3>
            <p>You are a high-net worth investor if you:</p>
            <ul>
              <li>had an annual income in the last year of &pound;100,000 or more; or</li>
              <li>had net assets of &pound;250,000 or more in the last year.</li>
            </ul>
            <p class="mb-0">
              You are required to read the full statutory statement <a
                href="/docs/high-net-certificate.pdf"
                target="_blank">which can be found here</a> by
                selecting this you are confirming your electronic signature of the certificate.
            </p>
          </div>
          <div class="card-footer">
            <div
              :class="{ 'invisible': selected('High-net') }"
              class="text-center">
              <base-button primary @click="payload.investorType = 'High-net'">Select</base-button>
            </div>
          </div>
        </div>
        <div class="card" :class="{ 'bg-success text-white': selected('Sophisticated') }">
          <div class="card-body">
            <h3 class="card-title text-center">Sophisticated</h3>
            <p>You are a sophisticated investor if you:</p>
            <ul>
              <li>a member of a network of business angels and have been for the last 6 months; or</li>
              <li>have made more than 1 investment in an unlisted company (including SPVs) in the last 2 years; or</li>
              <li>have worked for the last 2 years in private equity or the provision of finance to SMEs; or</li>
              <li>are (or have been in the 2 years prior) a director of a company with a turnover of at least &pound;1m.</li>
            </ul>
            <p class="mb-0">
              You are required to read the full statutory statement <a
                href="/docs/sophisticated-certificate.pdf"
                target="_blank">which can be found here</a> and by
                selecting this you are confirming your electronic signature of the certificate.
            </p>
          </div>
          <div class="card-footer">
            <div
              :class="{ 'invisible': selected('Sophisticated') }"
              class="text-center">
              <base-button primary @click="payload.investorType = 'Sophisticated'">Select</base-button>
            </div>
          </div>
        </div>
      </div>
      <div class="card border-top-0" :class="{ 'bg-success text-white': selected('None') }">
        <div class="card-body">
          <h3 class="card-title text-center">None of the above</h3>
          <p class="mb-0">
            As Saxon Trust offers investments in secured property loans, we want to ensure that everyone
            fully understands the investments so do not accept investors if they are unable to self-certify
            as one of the above types of investors. If you meet the requirements in the future, you can log
            back in using your email address and password and complete the relevant certification.
          </p>
        </div>
        <div class="card-footer">
          <div
            :class="{ 'invisible': selected('None') }"
            class="text-center">
            <base-button primary @click="payload.investorType = 'None'">Select</base-button>
          </div>
        </div>
      </div>
      <div class="text-right">
        <base-button
          :disabled="payload.investorType === '' || payload.investorType === 'None'"
          icon-right="arrow-right"
          :loading="saving"
          primary
          submit>
          Continue
        </base-button>
      </div>
    </form>
  </base-content>
</template>

<script>
import { mapActions } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'

export default {
  components: {
    HeroHeader
  },

  data: () => ({
    saving: false,
    payload: {
      _id: '',
      investorType: ''
    }
  }),

  async created () {
    const profile = this.$_.cloneDeep(this.$auth.user.profile)

    this.payload._id = profile._id
    this.payload.investorType = profile.investorType
  },

  methods: {
    selected (type) {
      return this.payload.investorType === type
    },

    async submit () {
      if (!this.payload.investorType) {
        this.$flash.failure('Please confirm what type of investor you are.')
        return
      }

      this.saving = true

      await this.updateProfile(this.payload)
      await this.setMeta({ key: 'registrationComplete', value: true })

      this.generateInvestorCertificate()

      this.$router.push({ name: 'dashboard' })
    },

    ...mapActions({
      generateInvestorCertificate: 'core/users/generate-investor-certificate',
      setMeta: 'core/auth/set-meta',
      updateProfile: 'core/auth/update-profile'
    })
  }
}
</script>
